export default __webpack_public_path__ + "static/media/Lord.21197425.svg";